import { ItemDefinition } from '../types/Item.types';
import { ConsumableDefinition } from '../types/Item.types';

// === DÉFINITIONS DES ITEMS ===

/** Labels courts pour identifier le slot d'un item */
export const SLOT_LABELS: Record<string, string> = {
  weapon: '⚔️ Arme',
  armor: '🛡️ Armure',
  belt: '🪢 Ceinture',
  ring: '💍 Anneau',
  boots: '👢 Bottes',
  backpack: '🎒 Sac',
};

export const ITEM_DEFINITIONS: Record<string, ItemDefinition> = {

  // ========== ARMES (9) ==========

  cutlass: {
    id: 'cutlass',
    name: 'Coutelas Rouillé',
    emoji: '🗡️',
    iconId: 'weapon-coutelas',
    slot: 'weapon',
    rarity: 'common',
    description: 'Lame basique de pirate. +1 ATK.',
    bonuses: { attack: 1 },
  },
  boarding_axe: {
    id: 'boarding_axe',
    name: "Hache d'Abordage",
    emoji: '🪓',
    iconId: 'weapon-hache',
    slot: 'weapon',
    rarity: 'uncommon',
    description: 'Lourde mais dévastatrice. +2 ATK.',
    bonuses: { attack: 2 },
  },
  dagger: {
    id: 'dagger',
    name: 'Dague Empoisonnée',
    emoji: '🔪',
    iconId: 'weapon-dague',
    slot: 'weapon',
    rarity: 'uncommon',
    description: 'Rapide et vicieuse. +1 ATK, +1 PM.',
    bonuses: { attack: 1, pm: 1 },
  },
  flintlock: {
    id: 'flintlock',
    name: 'Pistolet à Silex',
    emoji: '🔫',
    iconId: 'weapon-pistolet',
    slot: 'weapon',
    rarity: 'rare',
    description: 'Tire à distance. +2 ATK, +2 portée, +1 PA.',
    bonuses: { attack: 2, range: 2, pa: 1 },
  },
  anchor: {
    id: 'anchor',
    name: 'Ancre de Combat',
    emoji: '⚓',
    iconId: 'weapon-ancre',
    slot: 'weapon',
    rarity: 'rare',
    description: 'Arme brutale. +4 ATK, -1 PM.',
    bonuses: { attack: 4, pm: -1 },
  },
  sabre_captain: {
    id: 'sabre_captain',
    name: 'Sabre du Capitaine',
    emoji: '⚔️',
    iconId: 'weapon-sabre-capitaine',
    slot: 'weapon',
    rarity: 'rare',
    description: 'Lame noble et tranchante. +3 ATK, +1 PA.',
    bonuses: { attack: 3, pa: 1 },
  },
  harpoon: {
    id: 'harpoon',
    name: 'Harpon Maudit',
    emoji: '🔱',
    iconId: 'weapon-harpon',
    slot: 'weapon',
    rarity: 'uncommon',
    description: 'Portée moyenne, perçant. +2 ATK, +1 portée.',
    bonuses: { attack: 2, range: 1 },
  },
  bone_club: {
    id: 'bone_club',
    name: 'Gourdin en Os',
    emoji: '🦴',
    iconId: 'weapon-gourdin',
    slot: 'weapon',
    rarity: 'common',
    description: 'Solide et fiable. +1 ATK.',
    bonuses: { attack: 1 },
  },
  kraken_tentacle: {
    id: 'kraken_tentacle',
    name: 'Tentacule du Kraken',
    emoji: '🐙',
    iconId: 'weapon-tentacule',
    slot: 'weapon',
    rarity: 'rare',
    description: 'Vivante et imprévisible. +4 ATK, +1 portée, -1 PA.',
    bonuses: { attack: 4, range: 1, pa: -1 },
  },

  // ========== ARMURES (6) ==========

  torn_shirt: {
    id: 'torn_shirt',
    name: 'Chemise Déchirée',
    emoji: '👕',
    iconId: 'armor-chemise',
    slot: 'armor',
    rarity: 'common',
    description: 'Vaut mieux que rien. +1 DEF.',
    bonuses: { defense: 1 },
  },
  leather_coat: {
    id: 'leather_coat',
    name: 'Manteau de Cuir',
    emoji: '🧥',
    iconId: 'armor-manteau',
    slot: 'armor',
    rarity: 'uncommon',
    description: 'Résistant et souple. +1 DEF, +3 HP.',
    bonuses: { defense: 1, maxHp: 3 },
  },
  captain_plate: {
    id: 'captain_plate',
    name: 'Plastron du Capitaine',
    emoji: '🛡️',
    iconId: 'armor-plastron',
    slot: 'armor',
    rarity: 'rare',
    description: 'Armure lourde. +3 DEF, +5 HP, -1 PM.',
    bonuses: { defense: 3, maxHp: 5, pm: -1 },
  },
  shark_skin: {
    id: 'shark_skin',
    name: 'Peau de Requin',
    emoji: '🦈',
    iconId: 'armor-requin',
    slot: 'armor',
    rarity: 'uncommon',
    description: 'Rugueuse et résistante. +2 DEF.',
    bonuses: { defense: 2 },
  },
  ghost_cloak: {
    id: 'ghost_cloak',
    name: 'Cape Fantôme',
    emoji: '👻',
    iconId: 'armor-cape-fantome',
    slot: 'armor',
    rarity: 'rare',
    description: 'Insaisissable. +2 DEF, +2 PM, +2 HP.',
    bonuses: { defense: 2, pm: 2, maxHp: 2 },
  },
  coral_mail: {
    id: 'coral_mail',
    name: 'Cotte de Corail',
    emoji: '🪸',
    iconId: 'armor-corail',
    slot: 'armor',
    rarity: 'uncommon',
    description: 'Protège mais ralentit. +2 DEF, +2 HP.',
    bonuses: { defense: 2, maxHp: 2 },
  },

  // ========== CEINTURES (4) ==========

  pirate_belt: {
    id: 'pirate_belt',
    name: 'Ceinture de Pirate',
    emoji: '🪢',
    iconId: 'belt-pirate',
    slot: 'belt',
    rarity: 'common',
    description: 'Solide ceinture de cuir. +2 HP.',
    bonuses: { maxHp: 2 },
  },
  ammo_belt: {
    id: 'ammo_belt',
    name: 'Bandoulière à Munitions',
    emoji: '🎖️',
    iconId: 'belt-bandouliere',
    slot: 'belt',
    rarity: 'uncommon',
    description: 'Toujours prêt à tirer. +1 PA.',
    bonuses: { pa: 1 },
  },
  voodoo_sash: {
    id: 'voodoo_sash',
    name: 'Ceinture Vaudou',
    emoji: '🧿',
    iconId: 'belt-vaudou',
    slot: 'belt',
    rarity: 'rare',
    description: 'Imprégnée de magie noire. +1 PA, +1 ATK, +4 HP.',
    bonuses: { pa: 1, attack: 1, maxHp: 4 },
  },
  heavy_chain: {
    id: 'heavy_chain',
    name: 'Chaîne Lourde',
    emoji: '⛓️',
    iconId: 'belt-chaine',
    slot: 'belt',
    rarity: 'uncommon',
    description: 'Poids rassurant. +1 DEF, +2 HP.',
    bonuses: { defense: 1, maxHp: 2 },
  },

  // ========== ANNEAUX (5) ==========

  bone_ring: {
    id: 'bone_ring',
    name: "Anneau d'Os",
    emoji: '💀',
    iconId: 'ring-os',
    slot: 'ring',
    rarity: 'common',
    description: 'Taillé dans un tibia. +1 ATK.',
    bonuses: { attack: 1 },
  },
  cursed_ring: {
    id: 'cursed_ring',
    name: 'Anneau Maudit',
    emoji: '💍',
    iconId: 'ring-maudit',
    slot: 'ring',
    rarity: 'rare',
    description: 'Puissant mais dangereux. +3 ATK, +1 PA, -2 HP.',
    bonuses: { attack: 3, pa: 1, maxHp: -2 },
  },
  ring_of_tides: {
    id: 'ring_of_tides',
    name: 'Anneau des Marées',
    emoji: '🌊',
    iconId: 'ring-marees',
    slot: 'ring',
    rarity: 'uncommon',
    description: 'Flux et reflux. +2 PM, +2 HP.',
    bonuses: { pm: 2, maxHp: 2 },
  },
  signet_ring: {
    id: 'signet_ring',
    name: 'Chevalière du Quartier-Maître',
    emoji: '🏴‍☠️',
    iconId: 'ring-chevaliere',
    slot: 'ring',
    rarity: 'uncommon',
    description: 'Symbole d\'autorité. +1 DEF, +1 ATK.',
    bonuses: { defense: 1, attack: 1 },
  },
  kraken_eye: {
    id: 'kraken_eye',
    name: 'Œil du Kraken',
    emoji: '👁️',
    iconId: 'ring-kraken',
    slot: 'ring',
    rarity: 'rare',
    description: 'Voit tout. +2 portée, +1 PA.',
    bonuses: { range: 2, pa: 1 },
  },

  // ========== BOTTES (4) ==========

  old_boots: {
    id: 'old_boots',
    name: 'Vieilles Bottes',
    emoji: '👢',
    iconId: 'boots-vieilles',
    slot: 'boots',
    rarity: 'common',
    description: 'Usées mais fonctionnelles. +1 PM.',
    bonuses: { pm: 1 },
  },
  sea_boots: {
    id: 'sea_boots',
    name: 'Bottes de Marin',
    emoji: '🥾',
    iconId: 'boots-marin',
    slot: 'boots',
    rarity: 'uncommon',
    description: 'Antidérapantes. +2 PM, +2 HP.',
    bonuses: { pm: 2, maxHp: 2 },
  },
  sprint_greaves: {
    id: 'sprint_greaves',
    name: 'Jambières de Sprint',
    emoji: '💨',
    iconId: 'boots-sprint',
    slot: 'boots',
    rarity: 'rare',
    description: 'Vitesse pure. +3 PM, +2 HP. Item de mobilité.',
    bonuses: { pm: 3, maxHp: 2 },
  },
  iron_boots: {
    id: 'iron_boots',
    name: 'Bottes Ferrées',
    emoji: '🦿',
    iconId: 'boots-ferrees',
    slot: 'boots',
    rarity: 'uncommon',
    description: 'Solides comme le roc. +2 DEF, +3 HP, -1 PM.',
    bonuses: { defense: 2, maxHp: 3, pm: -1 },
  },
  // ========== SACS À DOS (4) ==========

  cloth_pouch: {
    id: 'cloth_pouch',
    name: 'Bourse en Toile',
    emoji: '👝',
    iconId: 'bag-bourse',
    slot: 'backpack',
    rarity: 'common',
    description: 'Un petit sac. +2 places.',
    bonuses: { capacity: 2 },
  },
  leather_bag: {
    id: 'leather_bag',
    name: 'Sac de Cuir',
    emoji: '🎒',
    iconId: 'bag-cuir',
    slot: 'backpack',
    rarity: 'uncommon',
    description: 'Solide et spacieux. +4 places.',
    bonuses: { capacity: 4 },
  },
  smuggler_pack: {
    id: 'smuggler_pack',
    name: 'Besace du Contrebandier',
    emoji: '💼',
    iconId: 'bag-contrebandier',
    slot: 'backpack',
    rarity: 'rare',
    description: 'Compartiments secrets. +6 places, +1 PM.',
    bonuses: { capacity: 6, pm: 1 },
  },
  cursed_chest_pack: {
    id: 'cursed_chest_pack',
    name: 'Coffre Maudit Portable',
    emoji: '📦',
    iconId: 'bag-coffre',
    slot: 'backpack',
    rarity: 'rare',
    description: 'Espace infini... presque. +8 places, -1 PM.',
    bonuses: { capacity: 8, pm: -1 },
  },

  // ========== ITEMS CRAFTABLES ==========

  improved_blade: {
    id: 'improved_blade',
    name: 'Lame Améliorée',
    emoji: '⚔️',
    iconId: 'weapon-lame-amelioree',
    slot: 'weapon',
    rarity: 'uncommon',
    description: 'Forgée à l\'atelier. +2 ATK.',
    bonuses: { attack: 2 },
  },
  reinforced_armor: {
    id: 'reinforced_armor',
    name: 'Armure Renforcée',
    emoji: '🛡️',
    iconId: 'armor-renforcee',
    slot: 'armor',
    rarity: 'uncommon',
    description: 'Plaques de fer rivetées. +2 DEF, +2 HP.',
    bonuses: { defense: 2, maxHp: 2 },
  },
  cursed_sabre: {
    id: 'cursed_sabre',
    name: 'Sabre Maudit',
    emoji: '🗡️',
    iconId: 'weapon-sabre-maudit',
    slot: 'weapon',
    rarity: 'rare',
    description: 'Lame imprégnée de malédiction. +3 ATK, +1 PA.',
    bonuses: { attack: 3, pa: 1 },
  },
  spectral_cape: {
    id: 'spectral_cape',
    name: 'Cape Spectrale',
    emoji: '👻',
    iconId: 'armor-cape-spectrale',
    slot: 'armor',
    rarity: 'rare',
    description: 'Tissée d\'ombres. +2 DEF, +2 PM.',
    bonuses: { defense: 2, pm: 2 },
  },
  abyss_ring: {
    id: 'abyss_ring',
    name: 'Anneau d\'Abîme',
    emoji: '🌀',
    iconId: 'ring-abime',
    slot: 'ring',
    rarity: 'rare',
    description: 'Puissance des profondeurs. +2 ATK, +1 PA, +3 HP.',
    bonuses: { attack: 2, pa: 1, maxHp: 3 },
  },

  // === Sprint 77 — Items génériques additionnels ===
  // Communs
  castaway_belt: {
    id: 'castaway_belt',
    name: 'Ceinture du Naufragé',
    emoji: '🧵',
    iconId: 'belt-cuir',
    slot: 'belt',
    rarity: 'common',
    description: 'Sangle improvisée. +3 HP.',
    bonuses: { maxHp: 3 },
  },
  marrow_ring: {
    id: 'marrow_ring',
    name: 'Anneau de Moelle',
    emoji: '🦴',
    iconId: 'ring-os',
    slot: 'ring',
    rarity: 'common',
    description: 'Os spongieux, vitalité brute. +3 HP.',
    bonuses: { maxHp: 3 },
  },
  tanned_boots: {
    id: 'tanned_boots',
    name: 'Bottes en Cuir Tanné',
    emoji: '👢',
    iconId: 'boots-cuir',
    slot: 'boots',
    rarity: 'common',
    description: 'Solides et confortables. +1 PM, +2 HP.',
    bonuses: { pm: 1, maxHp: 2 },
  },
  // Peu communs
  munition_belt: {
    id: 'munition_belt',
    name: 'Ceinture de Munitions',
    emoji: '🔫',
    iconId: 'belt-munitions',
    slot: 'belt',
    rarity: 'uncommon',
    description: 'Pleine de cartouches. +1 portée, +1 ATK.',
    bonuses: { range: 1, attack: 1 },
  },
  vigor_ring: {
    id: 'vigor_ring',
    name: 'Anneau de Vigueur',
    emoji: '💍',
    iconId: 'ring-vigueur',
    slot: 'ring',
    rarity: 'uncommon',
    description: 'Énergie débordante. +1 PA, +1 HP.',
    bonuses: { pa: 1, maxHp: 1 },
  },
  salty_cloak: {
    id: 'salty_cloak',
    name: 'Cape Salée',
    emoji: '🧥',
    iconId: 'armor-cape-salee',
    slot: 'armor',
    rarity: 'uncommon',
    description: 'Imprégnée d\'embruns. +2 DEF, +1 PM.',
    bonuses: { defense: 2, pm: 1 },
  },
  // Rares
  spectral_boots: {
    id: 'spectral_boots',
    name: 'Bottes Spectrales',
    emoji: '👻',
    iconId: 'boots-spectrales',
    slot: 'boots',
    rarity: 'rare',
    description: 'Effleurent le sol. +2 PM, +1 DEF, +4 HP.',
    bonuses: { pm: 2, defense: 1, maxHp: 4 },
  },
  death_ring: {
    id: 'death_ring',
    name: 'Anneau du Mort',
    emoji: '💀',
    iconId: 'ring-mort',
    slot: 'ring',
    rarity: 'rare',
    description: 'Le froid de la tombe. +2 ATK, +1 DEF, +2 HP.',
    bonuses: { attack: 2, defense: 1, maxHp: 2 },
  },

  // === Sprint 77 — Items signatures BOSS-ONLY (lootables uniquement à la mort du boss correspondant) ===
  captain_tricorne: {
    id: 'captain_tricorne',
    name: 'Tricorne du Capitaine',
    emoji: '🎩',
    iconId: 'armor-tricorne',
    slot: 'armor',
    rarity: 'rare',
    description: 'Trophée du Capitaine Maudit. +4 HP, +2 ATK, +1 portée.',
    bonuses: { maxHp: 4, attack: 2, range: 1 },
  },
  kraken_inkveil: {
    id: 'kraken_inkveil',
    name: 'Voile d\'Encre',
    emoji: '🌊',
    iconId: 'armor-voile-encre',
    slot: 'armor',
    rarity: 'rare',
    description: 'Tissée d\'encre du Kraken. +4 DEF, +1 PM, +2 HP.',
    bonuses: { defense: 4, pm: 1, maxHp: 2 },
  },
  voodoo_scepter: {
    id: 'voodoo_scepter',
    name: 'Sceptre de Vaudou',
    emoji: '🪄',
    iconId: 'weapon-sceptre-vaudou',
    slot: 'weapon',
    rarity: 'rare',
    description: 'Bâton de la Prêtresse. +3 ATK, +1 portée, +1 PA.',
    bonuses: { attack: 3, range: 1, pa: 1 },
  },

  // === Sprint 82 — Items légendaires uniques de Captain Jack Warraps (combat secret) ===
  jack_sabre_pistol: {
    id: 'jack_sabre_pistol',
    name: 'Le Sabre et le Pistolet de Jack',
    emoji: '⚔️',
    iconId: 'weapon-jack-sabre',
    slot: 'weapon',
    rarity: 'rare',
    description: 'Trophée de Captain Jack. +5 ATK, +2 portée, +1 PA.',
    bonuses: { attack: 5, range: 2, pa: 1 },
  },
  jack_ring: {
    id: 'jack_ring',
    name: 'J\'ai l\'Anneau',
    emoji: '💍',
    iconId: 'ring-jack',
    slot: 'ring',
    rarity: 'rare',
    description: 'Trophée de Captain Jack. +1 PA, +1 PM, +2 ATK.',
    bonuses: { pa: 1, pm: 1, attack: 2 },
  },

  // === Sprint 80 — Items uniques de la Taverne (gagnables uniquement à Liar's Dice) ===
  player_ring: {
    id: 'player_ring',
    name: 'Anneau du Joueur',
    emoji: '🎲',
    iconId: 'ring-joueur',
    slot: 'ring',
    rarity: 'rare',
    description: 'Trophée de la Taverne. +1 PA, +1 PM, +1 ATK.',
    bonuses: { pa: 1, pm: 1, attack: 1 },
  },
};

// === CONSOMMABLES ===

export const CONSUMABLE_DEFINITIONS: Record<string, ConsumableDefinition> = {
  health_potion: {
    id: 'health_potion',
    name: 'Potion de Rhum',
    emoji: '🍺',
    iconId: 'consumable-rhum',
    rarity: 'common',
    description: 'Soigne 8 HP. Le remède pirate.',
    effect: { heal: 8 },
  },
  big_health_potion: {
    id: 'big_health_potion',
    name: 'Élixir Vaudou',
    emoji: '🧪',
    iconId: 'consumable-elixir',
    rarity: 'uncommon',
    description: 'Soigne 15 HP. Goût douteux.',
    effect: { heal: 15 },
  },
  grenade: {
    id: 'grenade',
    name: 'Bombe à Poudre',
    emoji: '💣',
    iconId: 'consumable-bombe',
    rarity: 'uncommon',
    description: 'Inflige 6 dégâts en zone (rayon 2). Lancer jusqu\'à 4 cases.',
    effect: { damage: 6, aoe: 2, throwRange: 4 },
  },
  adrenaline: {
    id: 'adrenaline',
    name: 'Dose d\'Adrénaline',
    emoji: '⚡',
    iconId: 'consumable-adrenaline',
    rarity: 'uncommon',
    description: '+2 PA ce tour.',
    effect: { bonusPa: 2 },
  },
  speed_rum: {
    id: 'speed_rum',
    name: 'Rhum Rapide',
    emoji: '🏃',
    iconId: 'consumable-rhum-rapide',
    rarity: 'common',
    description: '+2 PM ce tour.',
    effect: { bonusPm: 2 },
  },
  bandage: {
    id: 'bandage',
    name: 'Bandage',
    emoji: '🩹',
    iconId: 'consumable-bandage',
    rarity: 'common',
    description: 'Soigne 6 HP. Mini-soin économique.',
    effect: { heal: 6 },
  },

  // === Sprint 80 — Consommables uniques de la Taverne ===
  loaded_dice: {
    id: 'loaded_dice',
    name: 'Dés Truqués',
    emoji: '🎲',
    iconId: 'consumable-des-truques',
    rarity: 'rare',
    description: 'Trophée Taverne. Soigne 10 HP + 1 PA.',
    effect: { heal: 10, bonusPa: 1 },
  },
  tavern_rum: {
    id: 'tavern_rum',
    name: 'Rhum du Tavernier',
    emoji: '🍻',
    iconId: 'consumable-rhum-tavernier',
    rarity: 'rare',
    description: 'Trophée Taverne. +5 PA ce tour. Tordu, mais efficace.',
    effect: { bonusPa: 5 },
  },
};

// === TABLES DE LOOT ===

export const LOOT_TABLES = {
  common: ['cutlass', 'torn_shirt', 'dagger', 'bone_club', 'pirate_belt', 'bone_ring', 'old_boots', 'cloth_pouch', 'castaway_belt', 'marrow_ring', 'tanned_boots'],
  uncommon: ['boarding_axe', 'dagger', 'leather_coat', 'harpoon', 'shark_skin', 'coral_mail', 'ammo_belt', 'heavy_chain', 'ring_of_tides', 'signet_ring', 'sea_boots', 'iron_boots', 'leather_bag', 'munition_belt', 'vigor_ring', 'salty_cloak'],
  rare: ['flintlock', 'anchor', 'captain_plate', 'sabre_captain', 'ghost_cloak', 'kraken_tentacle', 'voodoo_sash', 'cursed_ring', 'kraken_eye', 'sprint_greaves', 'smuggler_pack', 'cursed_chest_pack', 'spectral_boots', 'death_ring'],
} as const;

/**
 * Items signatures débloqués UNIQUEMENT à la mort du boss correspondant.
 * Ne sont pas dans LOOT_TABLES.rare — ne peuvent jamais apparaître ailleurs.
 * Sprint 77 (Phase 7).
 */
export const BOSS_SIGNATURE_ITEMS: Record<string, string> = {
  boss: 'captain_tricorne',          // Capitaine Maudit
  boss_kraken: 'kraken_inkveil',     // Kraken Abyssal
  boss_voodoo: 'voodoo_scepter',     // Prêtresse Vaudou
};

// Tables de loot consommables (utilisées séparément)
export const CONSUMABLE_LOOT = {
  common: ['health_potion', 'speed_rum', 'bandage'],
  uncommon: ['grenade', 'adrenaline', 'big_health_potion'],
} as const;
